import React from 'react'
import convertToAnswerLetters from '../../../../helpers/assessment/convertToAnswerLetters';

export default function AnswerKeyQuestion({number, correctAnswer, yourAnswer}) {
  let yourAns = ''
  yourAnswer ? yourAns = convertToAnswerLetters(number, yourAnswer) : null
  const correctAns = convertToAnswerLetters(number, correctAnswer)
  

  return (
    <div className="question">
      <span className="question-number">{`${number}.`}</span>
      <span 
        className={`answer-chosen${yourAns === correctAns ? '' : ' incorrect'}`}
      >
        {yourAns}
      </span>
      <span className="correct-answer">{correctAns}</span>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/AnswerKeyQuestion.js